<template>
    <div class="m-nav-bar-container">
        <div class="nav-bar-box">
            <div class="nav-box-sec" v-for="(item, idx) in NavMenusList" :key="idx"
                :class="{ 'sec-active': item.name === tabsValue }" @click="handleNavChange(item.name)">
                <n-icon size="24" class="icon-nav" :class="{ 'scla-icon': item.name === tabsValue }">
                    <img v-if="item.name === tabsValue" :src="item.actIcon" :alt="item.title" />
                    <img v-else :src="item.icon" :alt="item.title" />
                </n-icon>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { NIcon } from "naive-ui";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { Menu, Home, Medkit, PaperPlane, Folder, Map } from "@vicons/ionicons5";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useCalCScreenMinWidth } from "@/composables/useCalcScreenMinWidth";
import { NavMenusList } from "@/constant";
import { MessageAlert } from "@/composables/useMessageAlert";

const props = defineProps({
    isHome: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
});

const router = useRouter();
const { screenWinWidth } = useCalCScreenMinWidth();
const store = useStore();

const tabsValue = ref<string>("Home");
const isSrollTopDis = ref<boolean>(false);
const showMenuPopover = ref<boolean>(false);
const showPopover = ref<boolean>(false);
const isShowLoginAndRegisterModal = ref<boolean>(false);
const isShowDoctorAuthenticationModal = ref<boolean>(false);
const showConfirmLoginOutModal = ref<boolean>(false);
const isLogined = computed(() => {
    return store.getters["user/getLoginStatus"];
});
const showLoginModal = computed(() => {
    return store.getters["user/getShowLoginModal"];
});
const userInfo = computed(() => {
    return store.getters["user/getUserInfo"];
});

// 切换tab
const handleNavChange = (value: string | number) => {
    // console.log(value);
    switch (value) {
        case "Home":
            router.push({ path: "/mobile" });
            tabsValue.value = "Home";
            break;
        case "Medical":
            router.push({ path: "/mobile/medical" });
            tabsValue.value = "Medical";
            break;
        case "Posts":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/addpost" });
            tabsValue.value = "Posts";
            break;
        case "Messages":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/message" });
            tabsValue.value = "Messages";
            break;
        case "User":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/usercenter" });
            tabsValue.value = "User";
            break;
    }
};

// onMounted(() => {});
</script>

<style lang="scss" scoped>
.m-nav-bar-container {
    position: fixed;
    bottom: 21px;
    left: 0;
    right: 0;
    margin: 0 12px;
    z-index: 999;

    .nav-bar-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 30px;
        padding: 10px 40px;
        border-radius: 50px;
        background-color: rgba(0, 0, 0, 0.8);

        .nav-box-sec {
            display: flex;
            align-items: center;
            cursor: pointer;

            .icon-nav {
                >img {
                    width: 24px;
                    height: 24px;
                }
            }

            .scla-icon {
                transform: scale(1.2);
            }
        }

        .sec-active {
            position: relative;
        }

        .sec-active::before {
            content: "";
            position: absolute;
            top: -13px;
            left: 50%;
            transform: translateX(-50%);
            width: 18px;
            height: 3px;
            border-radius: 0px 0px 2px 2px;
            background-color: #fff;
        }
    }
}
</style>
